module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stepActive.text_size === 'long') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.placeholderText),
      expression: "placeholderText"
    }],
    staticClass: "klickbox-step-input-edit",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.placeholderText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.placeholderText = $event.target.value
      }
    }
  }) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-51edcece!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/text/Textarea.vue
 ** module id = 826
 ** module chunks = 1
 **/